// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/InvitaeTakserModal/index.css
// module id = 2554
// module chunks = 0